export default "__VITE_ASSET__C1Qrfr4n__"